module.exports = __webpack_public_path__ + "static/media/30-iveco-mercedes.80492eba.jpg";